import tokenApiService from '@/request/token/token.api.service';
import { useEffect, useState } from 'react';
import { ITokenActivity } from '@/request/token/token.response.interface';
import { ITokenActivityReq } from '@/request/token/token.request.interface';
import { useBoomWallet } from '@boomeme/wallet-sdk';

export const useTokenActivity = (params: ITokenActivityReq) => {
  const { chain } = useBoomWallet();
  const [loading, setLoading] = useState(false);
  const [activityList, setActivityList] = useState<ITokenActivity[]>([]);

  const fetchActivityList = async () => {
    try {
      setLoading(true);
      const res = await tokenApiService.getTokenActivity(params);
      if (res.code == 0) {
        setActivityList(res.data.items);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params.tokenAddress && params?.tokenAddress.length > 0) {
      fetchActivityList();
    }
  }, [params, chain]);

  return {
    fetchActivityList,
    setActivityList,
    activityList,
    loading,
  };
};
